import { PrimaryTextButton } from '@carvana/merch-components/helios/TextButton';
import { useGetCkPromoFromDiscountContext } from '~/hooks/common/creditKarmaPromo';
import PriceTag from '~/icons/PriceTag';
import getIsWithinNDay from '~/utilities/date/getIsWithinNDay';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type OwnProps = {
  setCreditKarmaPromoModalOpen: (open: boolean) => void;
};

const CreditKarmaPromoBanner = ({ setCreditKarmaPromoModalOpen }: OwnProps) => {
  const { shouldShowCkPromo, creditKarmaPromoAmount, expirationDate } =
    useGetCkPromoFromDiscountContext();
  const isWithinFiveDays = getIsWithinNDay(expirationDate, 5);

  return shouldShowCkPromo ? (
    <div className="flex w-full items-center justify-center gap-md bg-background-informational-subtle p-xl">
      <PriceTag />
      <span className="text-text-strong t-strong-sm">
        {isWithinFiveDays
          ? `Don’t miss your $${formatAndDropDecimal(
              creditKarmaPromoAmount
            )} savings!`
          : `$${formatAndDropDecimal(
              creditKarmaPromoAmount
            )} Credit Karma savings applied`}
      </span>
      <PrimaryTextButton
        data-analytics-id="Credit Karma Banner - Details"
        className="px-0 t-link-sm"
        onClick={() => setCreditKarmaPromoModalOpen(true)}
      >
        Details
      </PrimaryTextButton>
    </div>
  ) : null;
};

export default CreditKarmaPromoBanner;
